import {
  routePathToRegex,
  shouldReloadForVersionMismatch,
} from "@thalamos/common";

import { config } from "./config.js";
import { RELOAD_SAFE_ROUTE_PATHS } from "./reloadSafeRoutePaths.js";

const VERSION_REFRESH_KEY = "aspire-version-refresh";

const ALLOWED_PATHS = RELOAD_SAFE_ROUTE_PATHS.map(routePathToRegex);

export function checkVersionMismatch(
  serverVersion: string | null | undefined,
): void {
  if (
    !shouldReloadForVersionMismatch(
      serverVersion,
      config.version ?? "unknown",
      window.location.pathname,
      ALLOWED_PATHS,
      localStorage.getItem(VERSION_REFRESH_KEY),
      Date.now(),
    )
  )
    return;

  localStorage.setItem(VERSION_REFRESH_KEY, String(Date.now()));
  window.location.reload();
}
